import { Button, DatePicker, Form } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import dayjs, { Dayjs } from 'dayjs'
import { useEffect, useMemo } from 'react'
import { FormSection } from '@/presentation/common/components/FormSection.tsx'
import { useCrud } from '@/presentation/common/hooks/crud/useCrud.ts'
import { FormLayout } from '@/presentation/common/layout/FormLayout.tsx'
import { useDownloadReport } from '@/presentation/fuelConsumeReport/hooks/useDownloadReport.ts'

type FuelConsumeReportFields = {
  month: Dayjs
}

export const FuelConsumeReport = () => {
  const initialValues = useMemo(() => ({
    month: dayjs().startOf('month'),
  }), [])

  const messageApiKey = 'FuelConsumeReport-alert'
  const { submit, isLoading, isError, message, isSuccess, lastUpdate, data: file } = useDownloadReport()
  useCrud({ messageApiKey, message, isSuccess, isLoading, isError })

  const onSubmit = async (values: FuelConsumeReportFields) => {
    await submit({
      since : values.month.startOf('month').toISOString(),
      until : values.month.endOf('month').toISOString(),
    })
  }

  useEffect(() => {
    if (!isLoading && file) {
      window.open(URL.createObjectURL(file))
    }
  }, [ lastUpdate, file ])

  return (
    <FormLayout title="Reporte consumo de combustible">
      <section className="app-card">
        <Form
          layout="horizontal"
          labelCol={{ span: 4 }}
          labelAlign="left"
          labelWrap
          colon={false}
          initialValues={initialValues}
          onFinish={onSubmit}
        >
          <FormSection title="Filtros">
            <FormItem
              label="Mes"
              name="month"
              rules={[{ required: true }]}
            >
              <DatePicker picker="month" format="MMMM-YYYY" className="w-full"/>
            </FormItem>
          </FormSection>

          <div className="flex justify-center gap-2.5 pb-2">
            <Button size="small" type="primary" htmlType="submit" disabled={isLoading}>Obtener reporte</Button>
          </div>
        </Form>
      </section>
    </FormLayout>
  )
}
